import * as XLSX from "xlsx";

export const ExportInvoicetoExcel = (invoices, statusLabel = "all") => {
  if (!invoices || invoices.length === 0) {
    console.warn("No invoices to export.");
    return;
  }

  const rows = [];

  invoices.forEach((invoice) => {
    const {
      invoiceNumber,
      clientName,
      totalAmount,
      subtotal,
      gstIncluded,
      cgstAmount,
      cgstPercentage,
      sgstAmount,
      sgstPercentage,
      igstAmount,
      igstPercentage,
      status,
      createdAt,
      updatedAt,
      items = [],
      payments = [],
    } = invoice;

    // Combine invoice-level data with each item
    items.forEach((item, itemIndex) => {
      const {
        name: itemName,
        description,
        qty,
        rate,
        amount,
      } = item;

      const paymentInfo = payments.map(p => 
        `${p.paymentType}: ₹${p.amount} (${new Date(p.paymentDate).toLocaleDateString()})`
      ).join(" | ");

      rows.push({
        "Invoice #": invoiceNumber,
        "Client Name": clientName,
        "Status": status,
        "Created At": new Date(createdAt).toLocaleDateString(),
        "Updated At": new Date(updatedAt).toLocaleDateString(),
        "GST Included": gstIncluded ? "Yes" : "No",

        "Subtotal": subtotal,
        "Total Amount": totalAmount,

        "CGST %": cgstPercentage,
        "CGST ₹": cgstAmount,
        "SGST %": sgstPercentage,
        "SGST ₹": sgstAmount,
        "IGST %": igstPercentage,
        "IGST ₹": igstAmount,

        "Item #": itemIndex + 1,
        "Item Name": itemName,
        "Description": description,
        "Qty": qty,
        "Rate": rate,
        "Amount": amount,

        "Payments": paymentInfo || "N/A",
      });
    });

    // If no items, still push invoice-level row
    if (items.length === 0) {
      const paymentInfo = payments.map(p => 
        `${p.paymentType}: ₹${p.amount} (${new Date(p.paymentDate).toLocaleDateString()})`
      ).join(" | ");

      rows.push({
        "Invoice #": invoiceNumber,
        "Client Name": clientName,
        "Status": status,
        "Created At": new Date(createdAt).toLocaleDateString(),
        "Updated At": new Date(updatedAt).toLocaleDateString(),
        "GST Included": gstIncluded ? "Yes" : "No",

        "Subtotal": subtotal,
        "Total Amount": totalAmount,

        "CGST %": cgstPercentage,
        "CGST ₹": cgstAmount,
        "SGST %": sgstPercentage,
        "SGST ₹": sgstAmount,
        "IGST %": igstPercentage,
        "IGST ₹": igstAmount,

        "Item #": "-",
        "Item Name": "-",
        "Description": "-",
        "Qty": "-",
        "Rate": "-",
        "Amount": "-",

        "Payments": paymentInfo || "N/A",
      });
    }
  });

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

  XLSX.writeFile(workbook, `Invoices-${statusLabel}-${Date.now()}.xlsx`);
};
